<template>
  <div class="default admin-interfaces-settings admin-penal-code v-step-admin-penal-code">
    <PenalCodeUploadPopup :active="isPenalCodeUploadPopupOpen" @close="isPenalCodeUploadPopupOpen = false" />
    <div class="title">
      <div class="left">
        <h1>{{ $t('admin.penal-code.title') }}</h1>
      </div>

      <div class="right">
        <div class="add-article">
          <button class="orange-full col-pc-fit col-smobile-12">
            <div class="icon">
              <i class="fa fa-plus"></i>
            </div>
            <div class="text col-smobile-displaynone">
              <p>{{ $t('admin.penal-code.add-article') }}</p>
            </div>
          </button>
        </div>
        <div class="upload-icon col-smobile-displaynone" @click="isPenalCodeUploadPopupOpen = true">
          <a href="#">
            <i class="fas fa-upload"></i>
          </a>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="options">
        <div class="delete-all">
          <button class="danger-full">
            <div class="icon">
              <i class="fa fa-trash-alt"></i>
            </div>

            <div class="text">
              <p>{{ $t('admin.penal-code.delete-all') }}</p>
            </div>
          </button>
        </div>
        <div class="select-all">
          <label>
            <CustomInput
              class="custom-input primary"
              type="checkbox"
              name="all-articles"
              v-if="articlesAreSelectable"
            ></CustomInput>
            <p>
              {{ $t('admin.penal-code.select-all') }}
            </p>
          </label>
        </div>
      </div>
      <div class="top">
        <PenalCodeSearchInput @selectedCivilian="selectCivilian($event)" />
      </div>
      <div class="list">
        <ul class="grid col-pc-12 col-lgmobile-12" uk-accordion="multiple: true">
          <li class="article">
            <div class="accordion-tab-container">
              <CustomInput
                class="custom-input primary"
                type="checkbox"
                name="article"
                v-if="articlesAreSelectable"
              ></CustomInput>
              <div class="accordion-tab noselect col-all-12">
                <div class="accordion-tab-title col-all-12">
                  <h3 title="(Article 92) Possession non autorisée d'une arme à feu: infraction délibérée">
                    (Article 92) Possession non autorisée d'une arme à feu: infraction délibérée
                  </h3>
                </div>
                <div class="accordion-tab-buttons col-pc-auto col-mobile-3">
                  <div class="edit col-pc-6 col-mobile-12">
                    <button
                      class="warning-full col-mobile-12"
                      @click="articleDropdownOpen = !articleDropdownOpen"
                      :class="{ active: articleDropdownOpen }"
                    >
                      <i class="fas fa-edit"></i>
                    </button>
                  </div>
                  <div class="delete col-pc-6 col-mobile-12">
                    <button class="danger-full col-mobile-12">
                      <i class="fas fa-trash-alt"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <transition name="accordion">
              <div class="accordion-content" v-if="articleDropdownOpen">
                <div class="row">
                  <div class="column col-pc-6">
                    <div class="enabled-switch col-pc-2">
                      <p>{{ $t('admin.penal-code.enabled') }}</p>
                      <toggle-button
                        id="admin-penal-code-article-enabled"
                        v-model="$v.article.enabled"
                        :labels="{
                          checked: $t('admin.penal-code.on'),
                          unchecked: $t('admin.penal-code.off')
                        }"
                      ></toggle-button>
                    </div>
                    <div class="article-number col-pc-10">
                      <p>{{ $t('admin.penal-code.article-number') }}</p>
                      <CustomInput
                        name="article-number-input"
                        class="custom-input primary col-pc-12 col-mobile-12"
                        inputClasses="box col-pc-12 col-mobile-12"
                        type="text"
                        v-model="$v.article.number.$model"
                        :model="$v.article.number"
                        :placeholder="$t('admin.penal-code.article-number_placeholder')"
                      ></CustomInput>
                    </div>
                  </div>
                  <div class="article-title col-pc-6">
                    <p>{{ $t('admin.penal-code.article-title') }}</p>
                    <CustomInput
                      name="article-title-input"
                      class="custom-input primary col-pc-12 col-mobile-12"
                      inputClasses="box col-pc-12 col-mobile-12"
                      type="text"
                      v-model="$v.article.title.$model"
                      :model="$v.article.title"
                      :placeholder="$t('admin.penal-code.article-title_placeholder')"
                    ></CustomInput>
                  </div>
                </div>
                <div class="row">
                  <div class="article-description col-pc-6">
                    <p>
                      {{ $t('admin.penal-code.article-description') }}
                    </p>
                    <textarea
                      class="uk-textarea primary"
                      :placeholder="$t('admin.penal-code.article-description_placeholder')"
                      v-model="$v.article.description.$model"
                      :model="$v.article.description"
                    ></textarea>
                  </div>
                  <div class="article-punishment col-pc-6">
                    <p>
                      {{ $t('admin.penal-code.article-punishment') }}
                    </p>
                    <textarea
                      class="uk-textarea primary"
                      :placeholder="$t('admin.penal-code.article-punishment_placeholder')"
                      v-model="$v.article.punishment.$model"
                      :model="$v.article.punishment"
                    ></textarea>
                  </div>
                </div>
                <div class="row">
                  <div class="suggested-punishment col-pc-6">
                    <p>{{ $t('admin.penal-code.suggested-punishment') }}</p>
                    <vSelect
                      class="custom-select primary box col-pc-12"
                      v-model="article.suggestedPunishmentType"
                      :reduce="type => type.value"
                      :clearable="false"
                      :options="[
                        { label: $t('admin.penal-code.jail-time'), value: 'JAIL_TIME' },
                        { label: $t('admin.penal-code.community-work'), value: 'COMMUNITY_WORK' }
                      ]"
                    ></vSelect>
                  </div>
                  <div class="suggested-punishment-time col-pc-6">
                    <p>{{ $t('admin.penal-code.suggested-punishment-time') }}</p>
                    <div class="inputs col-pc-12">
                      <div class="amount col-all-6">
                        <CustomInput
                          class="col-pc-12 col-mobile-12 custom-input primary"
                          inputClasses="col-pc-12 col-mobile-12 box"
                          v-model.number="article.suggestedPunishmentTime"
                          type="number"
                        ></CustomInput>
                      </div>
                      <div class="timeframe col-all-6">
                        <vSelect
                          :clearable="false"
                          v-model="article.suggestedPunishmentTimeFrame"
                          :options="[
                            { label: $t('admin.penal-code.days'), value: 'DAYS' },
                            { label: $t('admin.penal-code.months'), value: 'MONTHS' },
                            { label: $t('admin.penal-code.years'), value: 'YEARS' }
                          ]"
                          :reduce="timeFrame => timeFrame.value"
                          class="custom-select custom-height col-pc-12 col-mobile-12 primary"
                        ></vSelect>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="button">
                  <button class="primary-full">
                    <p class="save-changes">{{ $t('admin.penal-code.save-changes') }}</p>
                  </button>
                </div>
              </div>
            </transition>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<style lang="less" scoped src="@/assets/less/dashboards/user-interfaces.less"></style>

<script>
import PenalCodeSearchInput from '@/components/PenalCodeSearchInput'
import PenalCodeUploadPopup from '@/components/PenalCodeUploadPopup'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'penal-code',
  components: {
    PenalCodeSearchInput,
    PenalCodeUploadPopup
  },
  data() {
    return {
      articlesAreSelectable: true,
      articleDropdownOpen: false,
      article: {
        active: true,
        number: 'Article 92',
        title: "Possession non autorisée d'une arme à feu: infraction délibérée",
        description:
          '94 (1) Sous réserve des paragraphes (3) et (4), commet une infraction quiconque occupe un véhicule automobile où il sait que se trouvent une arme à feu prohibée, une arme à feu à autorisation restreinte, une arme à feu sans restriction, une arme prohibée, une arme à autorisation restreinte, un dispositif prohibé — autre qu’une réplique — ou des munitions prohibées sauf si : a) dans le cas d’une arme à feu prohibée, d’une arme à feu à autorisation restreinte ou d’une arme à feu sans restriction : (i) soit celui-ci ou tout autre occupant du véhicule est titulaire d’un permis qui l’autorise à l’avoir en sa possession et, s’il s’agit d’une arme à feu prohibée ou d’une arme à feu à autorisation restreinte, est également titulaire de l’autorisation et du certificat d’enregistrement afférents, (ii) soit celui-ci avait des motifs raisonnables de croire qu’un autre occupant du véhicule était titulaire d’un permis autorisant ce dernier à l’avoir en sa possession et, s’il s’agit d’une arme à feu prohibée ou d’une arme à feu à autorisation restreinte, était également titulaire de l’autorisation et du certificat d’enregistrement afférents, (iii) soit celui-ci avait des motifs raisonnables de croire qu’un autre occupant du véhicule ne pouvait pas être reconnu coupable d’une infraction à la présente loi, en raison des articles 117.07 à 117.1 ou des dispositions de toute autre loi fédérale; b) dans le cas d’une arme prohibée, d’une arme à autorisation restreinte, d’un dispositif prohibé ou de munitions prohibées : (i) soit celui-ci ou tout autre occupant du véhicule est titulaire d’une autorisation ou d’un permis qui l’autorise à les transporter, (ii) soit celui-ci avait des motifs raisonnables de croire qu’un autre occupant du véhicule était titulaire d’une autorisation ou d’un permis qui l’autorisait à les transporter ou que ce dernier ne pouvait pas être reconnu coupable d’une infraction à la présente loi, en raison des articles 117.07 à 117.1 ou des dispositions de toute autre loi fédérale.',
        punishment:
          '(2) Quiconque commet l’infraction prévue au paragraphe (1) est coupable: a) soit d’un acte criminel passible d’un emprisonnement maximal de dix ans; b) soit d’une infraction punissable sur déclaration de culpabilité par procédure sommaire.',
        suggestedPunishmentType: 'JAIL_TIME',
        suggestedPunishmentTime: '10',
        suggestedPunishmentTimeFrame: 'YEARS'
      },
      isPenalCodeUploadPopupOpen: false
    }
  },
  validations: {
    article: {
      active: {
        required
      },
      number: {},
      title: {},
      description: {},
      punishment: {},
      suggestedPunishmentType: {},
      suggestedPunishmentTime: {},
      suggestedPunishmentTimeFrame: {}
    }
  }
}
</script>
